var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".7vw",
    height: ".7vw",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5H4C5 5 5.5 4.5 5.5 3.5V2.5C5.5 1.5 5 1 4 1H3C2 1 1.5 1.5 1.5 2.5V3.5C1.5 4.5 2 5 3 5Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H10C11 5 11.5 4.5 11.5 3.5V2.5C11.5 1.5 11 1 10 1H9C8 1 7.5 1.5 7.5 2.5V3.5C7.5 4.5 8 5 9 5Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H10C11 11 11.5 10.5 11.5 9.5V8.5C11.5 7.5 11 7 10 7H9C8 7 7.5 7.5 7.5 8.5V9.5C7.5 10.5 8 11 9 11Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H4C5 11 5.5 10.5 5.5 9.5V8.5C5.5 7.5 5 7 4 7H3C2 7 1.5 7.5 1.5 8.5V9.5C1.5 10.5 2 11 3 11Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.5a855a15e375221df4292cc256885014.svg";
export { ForwardRef as ReactComponent };